export const ApplicationName = 'Bluefield.Apps.BlueAccess';
export const Authority = `https://${process.env.REACT_APP_IDENTITY_HOST}`;
export const ApiGateway = `https://${process.env.REACT_APP_APIGATEWAY_HOST}/api/v1/`;
